import type { Nullable, VtsLog } from "@/models"
import { computed, provide } from "vue"
import { defineComponent, inferProps, ModalTitle, type ReactiveComponent } from "vue-utils"
import VtsMainDetails from "./VtsMainDetails"
import { VtsFormContext, VtsFormContextInjectionKey } from "./context"
import Modal from "@/components/Modal"

interface Props {
	existingVts: Nullable<VtsLog>
}

const VtsEntryForm: ReactiveComponent<Props> = (props) => {
	const context = new VtsFormContext(props.existingVts)
	provide(VtsFormContextInjectionKey, context)

	const title = computed(() => {
		return context.canEdit ? "Edit VTS Log" : "View VTS Log"
	})

	return () => props.existingVts == null ? (
		<VtsMainDetails/>
	) : (
		<Modal style={{ width: "74rem"}} class="vtsmodal flex flex-col">
			<ModalTitle title={title.value} />
			<hr />
			<VtsMainDetails />
		</Modal>
	)
}

export default defineComponent(VtsEntryForm, inferProps<Props>())
